﻿(function (angular) {
    'use strict';

    angular.module('Toyota.Directives')
        .directive('tyUniqueVehicle', function () {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ctrl) {
                    ctrl.$validators.uniquevehicle = function (modelValue, viewValue) {

                        // consider empty value valid (the required validator will cover this, as necessary)
                        if (ctrl.$isEmpty(modelValue)) {
                            return true;
                        }

                        var data = scope.getData();

                        var valid;

                        switch (elm.attr('id')) {
                            case scope.vehicleModelList[0]:
                                valid = viewValue.Value !== data.CarSelectionTwo &&
                                    viewValue.Value !== data.CarSelectionThree;
                                break;

                            case scope.vehicleModelList[1]:
                                valid = viewValue.Value !== data.CarSelectionOne &&
                                    viewValue.Value !== data.CarSelectionThree;
                                break;

                            case scope.vehicleModelList[2]:
                                valid = viewValue.Value !== data.CarSelectionOne &&
                                    viewValue.Value !== data.CarSelectionTwo;
                                break;
                            default:
                                valid = true;
                        }

                        return valid;
                    };
                }
            };

        });
})(window.angular);